import { Types } from "../actions/breakDownTasksActions";

const initialState = {
    poolList: {},
    unPlannedMaintenance: {},
    statusList: {},
    activeCounts: {},
    techList: {},
    areas: {},
    equipmentList: {},
    equipmentSubList: {},
    effects: {},
    reasonGroup: {},
    costCenters: {},
};

export const breakDownTasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_POOL_LIST:
            return {
                ...state,
                poolList: action.payload || state.poolList,
            };

        case Types.SET_UNPLANNED_MAINTENANCE:
            return {
                ...state,
                unPlannedMaintenance: action.payload || state.unPlannedMaintenance,
            };

        case Types.SET_UNPLANNED_MAINTENANCE_MULTIPLE:
            return {
                ...state,
                unPlannedMaintenance: action.payload || state.unPlannedMaintenance,
            };

        case Types.SET_MAINTENANCE_STATUS_LIST:
            return {
                ...state,
                statusList: action.payload || state.statusList,
            };
        case Types.SET_COUNTS:
            return {
                ...state,
                activeCounts: action.payload || state.activeCounts,
            };
        case Types.SET_TECH_LIST:
            return {
                ...state,
                techList: action.payload || state.techList,
            };
        case Types.SET_EQUIPMENT_MAIN_LIST:
            return {
                ...state,
                equipmentList: action.payload || state.equipmentList,
            };
        case Types.SET_AREAS:
            return {
                ...state,
                areas: action.payload || state.areas,
            };
        case Types.SET_EQUIPMENT_SUB_LIST:
            return {
                ...state,
                equipmentSubList: action.payload || state.equipmentSubList,
            };
        case Types.SET_REASON_GROUP:
            return {
                ...state,
                reasonGroup: action.payload || state.reasonGroup,
            };
        case Types.SET_EFFECTS:
            return {
                ...state,
                effects: action.payload || state.effects,
            };
        case Types.SET_COST_CENTERS:
            return {
                ...state,
                costCenters: action.payload || state.costCenters,
            };
        case Types.RESET_FILTER:
            return {
                ...state,
                costCenters: {},
                techList: {},
                effects: {},
                reasonGroup: {},
                areas: {},
            };
        case Types.RESET_TECH_LIST:
            return {
                ...state,
                techList: {},
            };
        case Types.RESET_STORE:
            return {
                ...state,
                techList: {},
                poolList: {},
                unPlannedMaintenance: {},
                activeCounts: {},
                statusList: {},
            };
        case Types.SET_AREA_LIST_TO_NULL:
            return {
                ...state,
                areas: {},
            };
        default:
            return state;
    }
};
